import React from "react";
import { Mail, MapPin } from "lucide-react";
import { PageShell, Section } from "../components/PageShell";
import { BookDemoButton } from "../components/BookDemoButton";

const EMAIL = "info@miseone.eu";

export const Contact = () => (
  <PageShell eyebrow="Contact" title="Get in touch." testId="contact-page">
    <p>
      One inbox for everything — questions about the product, sales, support, press,
      partnerships. A real person reads every message.
    </p>

    <Section heading="Email">
      <div className="flex items-start gap-4">
        <span className="mt-1 inline-flex h-9 w-9 flex-none items-center justify-center rounded-full border border-[var(--mo-line)] bg-white/60">
          <Mail size={16} strokeWidth={1.6} className="text-[#EA6A43]" />
        </span>
        <div>
          <a
            href={`mailto:${EMAIL}`}
            className="font-display text-2xl font-bold tracking-tight text-[#1b1a18] hover:text-[#EA6A43]"
            data-testid="contact-email"
          >
            {EMAIL}
          </a>
          <p className="mt-2 text-[15px] text-[#6b665e]">
            We reply within one business day, Monday to Friday, Helsinki time.
          </p>
        </div>
      </div>
    </Section>

    <Section heading="Location">
      <div className="flex items-start gap-4">
        <span className="mt-1 inline-flex h-9 w-9 flex-none items-center justify-center rounded-full border border-[var(--mo-line)] bg-white/60">
          <MapPin size={16} strokeWidth={1.6} className="text-[#EA6A43]" />
        </span>
        <div>
          <div
            className="font-display text-2xl font-bold tracking-tight text-[#1b1a18]"
            data-testid="contact-location"
          >
            Helsinki, Finland
          </div>
          <p className="mt-2 text-[15px] text-[#6b665e]">
            Built where the winters are long and the kitchens run hot.
          </p>
        </div>
      </div>
    </Section>

    <Section heading="See it in action">
      <p>
        If you would like a guided walk-through of MiseOne with your restaurant in mind,
        book a short demo.
      </p>
      <div className="mt-4">
        <BookDemoButton size="md" testId="contact-book-demo" />
      </div>
    </Section>
  </PageShell>
);

export default Contact;
